 import { FaUserPlus } from "react-icons/fa"; // Importing the FaUserPlus icon
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Nav } from '../../components/nav';
import { useAuth } from '../../navigation/AuthProvider';
import {
  add_new_worksession,
  change_selected_timeSchema,
  create_new_timeSchema,
  delete_existing_timeSchema,
  edit_worksession,
  publish_draft_schedule,
  recall_draft_schedule,
  remove_worksession,
  bulk_delete_worksessions,
  copy_week_schedule
} from '../../utils/scheduleRequests';
import '../css/Shift.css';
import { MdPublishedWithChanges } from "react-icons/md";
import { MdOutlineBusinessCenter } from "react-icons/md";
import { FaCalendarPlus, FaPlus, FaChevronDown, FaTrash, FaUser, FaEllipsisH } from "react-icons/fa";
import { SiGooglesheets } from "react-icons/si";
import { Toast } from "../../components/ToastPopup"
import OvertimeForShiftPopup from "../../components/OvertimeForShiftPopup";
import AbsenceForShiftPopup from "../../components/AbsenceForShiftPopup";
import { BreakForShiftPopup } from "../../components/BreakForShiftPopup";
import { MultipleDatesInShiftPopup } from "../../components/MultipleDatesInShiftPopup";
import ShiftApplicationsPopup from "../../components/ShiftApplicationsPopup";
import TrashPopup from "../../components/TrashPopup";

import axios from "axios";
import { BACKEND_URL } from "../../constants";

import { ImportExcelPopup } from "../../components/importExcelPopup";

import { CheckIfUserInProject } from "../../utils/checkIfUserInProject";
import { addEmployeesToProjectFromShift } from "../../utils/addEmployeesToProject";
import { CheckForOverlappingShifts } from "../../utils/CheckForOverlappingShifts";

import { getPermission } from "../../permissions/rolePermissions";

import ShiftCard from "../../components/shifts/ShiftCard";
import ShiftGridDay from "../../components/shifts/ShiftGridDay";
import WeekDayHeader from "../../components/shifts/WeekDayHeader";
import ShiftEditorModal from "../../components/shifts/ShiftEditorModal";
import ShiftTopBar from "../../components/shifts/ShiftTopBar";
import CopyWeekShiftPopup from "../../components/shifts/CopyWeekShiftPopup";
import {
  styleForVariant,
  badgeForVariant,
  applicationBadge,
  buildTooltip,
} from "../../components/shifts/ShiftUtils";

// Bas för alla chips
const pillBase = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  padding: '4px 10px',
  fontFamily: 'sans-serif',
  fontSize: '0.8125rem',
  fontWeight: 500,
  border: '1px solid transparent',
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
  whiteSpace: 'nowrap'
};

// ✅ Övertid (ljusblå) – nu med liten radie (matchar Frånvaro)
const chipOvertime = {
  backgroundColor: '#E0F2FE',
  borderColor: '#BAE6FD',
  color: '#075985',
  borderRadius: 4,
};

// ✅ Rast (ljus gråvit med bra kontrast) – också liten radie
const chipBreak = {
  backgroundColor: '#F3F4F6',
  borderColor: '#E5E7EB',
  color: '#111827',
  borderRadius: 4,
};

// (Frånvaro behålls som tidigare – liten radie)
const chipAbsence = {
  backgroundColor: '#FFF3CD',
  borderColor: '#FFEEBA',
  color: '#856404',
  borderRadius: 4,
};

// A shift is complete iff it has: date, startTime, endTime, project, and ≥1 employeeId
const isShiftComplete = (s) => Boolean(
  s &&
  s.date &&
  s.startTime &&
  s.endTime &&
  s.project &&
  Array.isArray(s.employees) &&
  s.employees.some(e => !!e.employeeId)
);

const isNonEmpty = (v) =>
  v !== undefined && v !== null && !(typeof v === "string" && v.trim() === "");

const compact = (obj) => Object.fromEntries(
  Object.entries(obj).filter(([, v]) => isNonEmpty(v))
);

// For incomplete shifts: yellow for minor; red for critical (missing time or project)
const getIncompleteStyle = (s) => {
  if (!s) return {};
  const missing = {
    date: !s.date,
    start: !s.startTime,
    end: !s.endTime,
    project: !s.project,
    employees: !(Array.isArray(s.employees) && s.employees.length > 0)
  };
  const critical = missing.project || missing.start || missing.end;

  return !isShiftComplete(s)
    ? (
      critical
        ? { backgroundColor: '#FEE2E2', border: '1px solid #FCA5A5' } // soft red
        : { backgroundColor: '#FFF7ED', border: '1px solid #FDBA74' } // soft yellow
    )
    : {};
};


export const Shift = () => {
  const {
    pays,
    employees,
    projects,
    setProjects,
    setAbsenceRules,
    absenceRules,
    company,
    user,
    draftSchedule,
    setDraftSchedule,
    timeSchemas,
    setTimeSchemas,
    overtimeRules,
    mostRecentTimeSchema,
    setMostRecentTimeSchema,
    setLoading
  } = useAuth();

  const pendingCount = 3;
  const [showShiftApplicationsPopup, setShowShiftApplicationsPopup] = useState(false)

  const employeesPermission = getPermission(user.role, "schedule");
  const canEditShifts = employeesPermission === "edit"

  console.log("can edit shift", canEditShifts)

  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());

  const [shifts, setShifts] = useState(draftSchedule || []);

  const [allProjects, setAllProjects] = useState(projects || []);
  const [allEmployees, setAllEmployees] = useState(employees || []);
  const [allTimeSchemas, setAllTimeSchemas] = useState(timeSchemas || [])
  const [allOvertimeRules, setAllOvertimeRules] = useState(overtimeRules || [])
  const [allAbsenceRules, setAllAbsenceRules] = useState(absenceRules || [])

  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedProject, setSelectedProject] = useState("");

  const [selectEmployeePopupVisible, setSelectEmployeePopupVisible] = useState(false);

  const [showOvertimeForShiftPopup, setShowOverTimeForShiftPopup] = useState(false)
  const [selectedEmployeeForOvertime, setSelectedEmployeeForOvertime] = useState(null);

  const [showAbsenceForShiftPopup, setShowAbsenceForShiftPopup] = useState(false)
  const [selectedEmployeeForAbsence, setSelectedEmployeeForAbsence] = useState(null)

  const [showBreakPopup, setShowBreakPopup] = useState(false)
  const [selectedEmployeeForBreak, setSelectedEmployeeForBreak] = useState(null)

  const [showMultipleDatesShiftPopup, setShowMultipleDatesShiftPopup] = useState(false);
  const [useMultipleDates, setUseMultipleDates] = useState(false);
  const [multipleDates, setMultipleDates] = useState([]);

  // For restoring popup state
  const [selectedMultipleStartDate, setSelectedMultipleStartDate] = useState(null);
  const [selectedMultipleEndDate, setSelectedMultipleEndDate] = useState(null);
  const [selectedMultipleMode, setSelectedMultipleMode] = useState("weekday"); // or "custom"
  const [selectedMultipleWeekdays, setSelectedMultipleWeekdays] = useState({ 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 0: false });
  const [selectedMultipleCustomDates, setSelectedMultipleCustomDates] = useState([]);

  const [selectedBreakIndex, setSelectedBreakIndex] = useState(null);
  const [selectedAbsenceIndex, setSelectedAbsenceIndex] = useState(null)
  const [selectedOvertimeIndex, setSelectedOvertimeIndex] = useState(null)

  const [shiftFormData, setShiftFormData] = useState({
    employees: [
      {
        employeeId: '',
        overtime: [],
        absences: [],
        breaks: [] // array of { from, to }
      }
    ],
    allowApplications: false,
    project: '',
    date: '',
    startTime: '',
    endTime: '',
    message: ""
  });

  




  const [buttonLoading, setButtonLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [employeesNotInProject, setEmployeesNotInProject] = useState([])
  const [overlappingShiftWarningText, setOverlappingShiftWarningText] = useState("")

  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);

  // NEW: Week / Month view switch
  const [viewMode, setViewMode] = useState("week");



  const [deleteMode, setDeleteMode] = useState(false);
  const [deleteType, setDeleteType] = useState("shift"); // "shift" | "day"
  const [selectedShiftIds, setSelectedShiftIds] = useState(new Set());
  const [selectedDates, setSelectedDates] = useState(new Set());


  const [showCopyWeekPopup, setShowCopyWeekPopup] = useState(false);


  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [moreMenuPosition, setMoreMenuPosition] = useState({ top: 0, left: 0 });
  const moreButtonRef = useRef(null);




  const [isDraggingShift, setIsDraggingShift] = useState(false);
  const lastWeekChangeRef = useRef(0);
  const scheduleContainerRef = useRef(null);

  const hoverNavTimeoutRef = useRef(null);
  const hoverNavIntervalRef = useRef(null);

  const [hoverDirection, setHoverDirection] = useState(null);


  const clearHoverNavigation = () => {

    if (hoverNavTimeoutRef.current) {
      clearTimeout(
        hoverNavTimeoutRef.current
      );

      hoverNavTimeoutRef.current = null;
    }

    if (hoverNavIntervalRef.current) {
      clearInterval(
        hoverNavIntervalRef.current
      );

      hoverNavIntervalRef.current = null;
    }

    setHoverDirection(null);
  };

const startHoverNavigation = (direction) => {

  clearHoverNavigation();

  setHoverDirection(direction);

  // vänta 1 sekund innan första week change
  hoverNavTimeoutRef.current = setTimeout(() => {

    changeWeek(direction);

    // fortsätt sedan varje sekund
    hoverNavIntervalRef.current = setInterval(() => {

      changeWeek(direction);

    }, 1000);

  }, 500);
};

  useEffect(() => {

    const handleStart = () => {
      setIsDraggingShift(true);
    };

    const handleEnd = () => {
      setIsDraggingShift(false);
    };

    window.addEventListener(
      "shift-drag-start",
      handleStart
    );

    window.addEventListener(
      "shift-drag-end",
      handleEnd
    );

    return () => {

      window.removeEventListener(
        "shift-drag-start",
        handleStart
      );

      window.removeEventListener(
        "shift-drag-end",
        handleEnd
      );
    };

  }, []);

  useEffect(() => {

    return () => {

      clearHoverNavigation();

    };

  }, []);




  useEffect(() => {
    const close = () => setShowMoreMenu(false);
    window.addEventListener("scroll", close);
    return () => window.removeEventListener("scroll", close);
  }, []);


  const [showTrashPopup, setShowTrashPopup] = useState(false);





useEffect(() => {
  setAllProjects(projects || []);
}, [projects]); 





  useEffect(() => {
    // Extract only valid employeeIds from the current employee objects
    const validEmployeeIds = shiftFormData.employees
      .map(emp => emp?.employeeId)
      .filter(id => id && id !== "");

    const projectSelected = shiftFormData.project !== "";
    const employeesSelected = validEmployeeIds.length > 0;

    if (projectSelected && employeesSelected) {
      const checkProject = async () => {
        const response = await CheckIfUserInProject({
          allProjects,
          employeesIds: validEmployeeIds,
          projectId: shiftFormData.project,
          allEmployees,
        });

        setEmployeesNotInProject(response);
      };

      checkProject();
    }
  }, [shiftFormData.project, shiftFormData.employees, allProjects, allEmployees]);

  useEffect(() => {
    // Kör bara när allt som behövs finns – annars nollställ varningen
    const hasAllRequired =
      typeof shiftFormData?.date === "string" &&
      typeof shiftFormData?.startTime === "string" &&
      shiftFormData.startTime.includes(":") &&
      typeof shiftFormData?.endTime === "string" &&
      shiftFormData.endTime.includes(":") &&
      Array.isArray(shiftFormData?.employees) &&
      shiftFormData.employees.some(e => !!e?.employeeId);

    if (!hasAllRequired) {
      setOverlappingShiftWarningText("");
      return;
    }

    // ⚠️ Sanera inkommande shifts: ta med bara de som har giltiga tider
    const sanitizedShifts = (Array.isArray(shifts) ? shifts : []).filter(s =>
      s &&
      typeof s.startTime === "string" && s.startTime.includes(":") &&
      typeof s.endTime === "string" && s.endTime.includes(":") &&
      !!s.date
    );

    (async () => {
      try {
        const warningText = await CheckForOverlappingShifts({
          startTime: shiftFormData.startTime,
          endTime: shiftFormData.endTime,
          allEmployees,
          allProjects,
          employees: shiftFormData.employees,
          shifts: sanitizedShifts, // 👈 endast kompletta skift
          date: shiftFormData.date,
          existingShiftId: (isEditing && editWorksession) ? editWorksession._id : null,
        });

        setOverlappingShiftWarningText(warningText || "");
      } catch (err) {
        console.error("CheckForOverlappingShifts failed", err);
        setOverlappingShiftWarningText("");
      }
    })();
  }, [
    shiftFormData.date,
    shiftFormData.startTime,
    shiftFormData.endTime,
    shiftFormData.employees,
    shifts,
    allEmployees,
    allProjects,
  ]);

  const [showCreateTimeSchemaPopup, setShowCreateTimeSchemaPopup] = useState(false)
  const [newTimeSchemaName, setNewTimeSchemaName] = useState("")
  const [selectedTimeSchema, setSelectedTimeSchema] = useState(mostRecentTimeSchema || "");

  const [isEditing, setIsEditing] = useState(false);
  const [editWorksession, setEditWorksession] = useState(null);

  const [publishPopupVisible, setPublishPopupVisible] = useState(false)

  const [lastPublishedDate, setLastPublishedDate] = useState(() => {
    const selectedSchema = allTimeSchemas.find((schema) => schema._id === selectedTimeSchema);
    if (!selectedSchema || !selectedSchema.lastPublishedDate) return "...";
    else return new Date(selectedSchema.lastPublishedDate).toISOString().split('T')[0];
  });

  const [newPublishDate, setNewPublishDate] = useState(lastPublishedDate)
  const [publishConfirmText, setPublishConfirmText] = useState("")

  const [recallPublish, setRecallPublish] = useState(false)
  const [deleteTimeSchema, setDeleteTimeSchema] = useState(false)

  const [importExcelPopupVisible, setImportExcelPopupVisible] = useState(false)

  const [loadedMonths, setLoadedMonths] = useState(new Set());
  const loadedMonthsRef = useRef(new Set());
  const loadingMonthsRef = useRef(new Set());

  const calendarRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };

    if (showCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showCalendar]);

  useEffect(() => {
    if (!showCalendar) return;

    const onKey = (e) => {
      if (e.key === "Escape") {
        setShowCalendar(false);
      }
    };

    document.addEventListener("keydown", onKey);

    return () => {
      document.removeEventListener("keydown", onKey);
    };
  }, [showCalendar]);

  useEffect(() => {
    // 🧹 Reset when company or time schema changes
    loadedMonthsRef.current = new Set();
    loadingMonthsRef.current = new Set();
    setLoadedMonths(new Set());
  }, [company?._id, selectedTimeSchema]);

  useEffect(() => {
    // 🧠 Sync loaded months from draftSchedule after login or refresh
    if (draftSchedule?.length > 0) {
      const monthsInSchedule = new Set();

      draftSchedule.forEach((shift) => {
        const date = new Date(shift.date);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        monthsInSchedule.add(`${year}-${month}`);
      });

      monthsInSchedule.forEach((key) => loadedMonthsRef.current.add(key));
      setLoadedMonths(new Set(loadedMonthsRef.current));
    }
  }, [draftSchedule]);

  const fetchShiftsForMonth = async (month, year) => {
    if (!company?._id || !selectedTimeSchema) return;

    const key = `${year}-${String(month).padStart(2, '0')}`;

    if (loadedMonthsRef.current.has(key) || loadingMonthsRef.current.has(key)) return;

    loadingMonthsRef.current.add(key);

    try {
      const res = await axios.get(`${BACKEND_URL}/get-shifts-for-month-shift-page`, {
        params: {
          companyId: company._id,
          year,
          month,
          timeSchemaId: selectedTimeSchema,
        },
      });

      if (res.data.status === "success" && Array.isArray(res.data.shifts)) {
        // ✅ Deduplicate based on _id
        setShifts(prev => {
          const existingIds = new Set(prev.map(s => s._id));
          const newShifts = res.data.shifts.filter(s => !existingIds.has(s._id));
          return [...prev, ...newShifts];
        });

        setDraftSchedule(prev => {
          const existingIds = new Set(prev.map(s => s._id));
          const newShifts = res.data.shifts.filter(s => !existingIds.has(s._id));
          return [...prev, ...newShifts];
        });

        loadedMonthsRef.current.add(key);
        setLoadedMonths(new Set(loadedMonthsRef.current));
      }
    } catch (err) {
      console.error("❌ Failed to fetch shifts:", err);
    } finally {
      loadingMonthsRef.current.delete(key);
    }
  };

  useEffect(() => {
    setLastPublishedDate(() => {
      const selectedSchema = allTimeSchemas.find((schema) => schema._id === selectedTimeSchema);
      if (!selectedSchema || !selectedSchema.lastPublishedDate) return "...";
      else return new Date(selectedSchema.lastPublishedDate).toISOString().split('T')[0];
    });
  }, [selectedTimeSchema, allTimeSchemas]);

  // se till att lastPublisedDate finns kvar på publicera popupen när man byter mellan återkalla och publicera
  useEffect(() => {
    setNewPublishDate(lastPublishedDate || "");
  }, [lastPublishedDate, recallPublish]);

  const handleChangeTimeSchema = async (e) => {
    const value = e.target.value;

    try {
      const data = await change_selected_timeSchema({ user, company, selectedTimeSchema: value });

      if (data.status === "success") {
        await setMostRecentTimeSchema(value)
        setSelectedTimeSchema(value)
      }

      return
    } catch (error) {
      console.error("Error changing time schema:", error);
      setToastType("error");
      setToastMessage("Kunde inte ändra schema, om det fortsätter att inte fungera vänligen skicka ett mail till kontakt@timesmart.se!");
      return
    }
  };

  // ── Safe date helpers ───────────────────────────────────────────────
  const toISODate = (d) => {
    if (!d) return "";
    if (typeof d === "string") {
      // normalize "YYYY-MM-DD" or ISO with time
      return d.includes("T") ? d.split("T")[0] : d;
    }
    if (d instanceof Date && !isNaN(d)) return d.toISOString().split("T")[0];
    try {
      const dt = new Date(d);
      return isNaN(dt) ? "" : dt.toISOString().split("T")[0];
    } catch { return ""; }
  };

  const monthKeyOf = (d) => {
    const s = toISODate(d);
    return s ? s.slice(0, 7) : ""; // "YYYY-MM" or ""
  };

  const handleShiftSubmit = async (e) => {
    e.preventDefault();

    const isNonEmptyLocal = (v) =>
      v !== undefined && v !== null && !(typeof v === "string" && v.trim() === "");

    const compactLocal = (obj) =>
      Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));

    const timeToMinutes = (timeStr) => {
      const [h, m] = String(timeStr || "0:0").split(":").map(Number);
      return h * 60 + (m || 0);
    };

    const shiftEndMinutes = timeToMinutes(shiftFormData.endTime);

    for (const emp of shiftFormData.employees) {
      if (emp.overtime && emp.overtime.length > 0) {
        for (const ot of emp.overtime) {
          const otStartMinutes = timeToMinutes(ot.from);
          // (intentionally unused as in your original)
        }
      }
    }

    if (useMultipleDates === true && multipleDates.length < 1) {
      alert("Måste välja minst ett giltigt datum");
      return;
    }

    setButtonLoading(true);


    // Build employees: include ALL rows (empty slots allowed)
    const normalizedEmployees = (shiftFormData.employees || []).map((emp) => ({
      employeeId: isNonEmptyLocal(emp.employeeId) ? emp.employeeId : null,
      overtime: emp.overtime || [],
      breaks: emp.breaks || [],
      absences: (emp.absences || []).map((a) => ({
        absenceType: a.absenceType,
        from: a.from || "",
        to: a.to || "",
        appliesWholeShift: !!a.appliesWholeShift,
        applyToAllDayShifts: !!a.applyToAllDayShifts,
      })),
    }));


    // CREATE data
    const workSessionDataCreate = compactLocal({
      ...(useMultipleDates ? { multipleDates } : { date: shiftFormData.date }),
      startTime: isNonEmptyLocal(shiftFormData.startTime) ? shiftFormData.startTime : undefined,
      endTime: isNonEmptyLocal(shiftFormData.endTime) ? shiftFormData.endTime : undefined,
      employees: normalizedEmployees.length ? normalizedEmployees : undefined,
      message: isNonEmptyLocal(shiftFormData.message) ? shiftFormData.message : undefined,

      allowApplications: !!shiftFormData.allowApplications,
    });

    // EDIT data
    const workSessionDataEdit = {
      ...(useMultipleDates ? { multipleDates } : { date: shiftFormData.date }),
      startTime: isNonEmptyLocal(shiftFormData.startTime) ? shiftFormData.startTime : null,
      endTime: isNonEmptyLocal(shiftFormData.endTime) ? shiftFormData.endTime : null,
      employees: normalizedEmployees,
      message: isNonEmptyLocal(shiftFormData.message) ? shiftFormData.message : null,

      allowApplications:!!shiftFormData.allowApplications,
    };

    if (isEditing) {
      console.log(workSessionDataEdit)
      const data = await edit_worksession({
        updatedFields: workSessionDataEdit,
        user,
        company,
        worksession: editWorksession,
        projectId: isNonEmptyLocal(shiftFormData.project) ? shiftFormData.project : null,
        timeSchemaId: selectedTimeSchema,
      });

      if (data.status === "success") {
        const updatedWorkSession = data.shift;
        const updatedShiftsForMonth = data.updatedShiftsForMonth;

        const normalizedUpdated = (updatedShiftsForMonth || []).map((s) => ({
          ...s,
          date: toISODate(s.date),
        }));
        const monthPrefix = monthKeyOf(updatedWorkSession?.date);

        setShifts((prev) => {
          const filtered = (prev || []).filter((shift) => monthKeyOf(shift?.date) !== monthPrefix);
          return [...filtered, ...normalizedUpdated];
        });

        setDraftSchedule((prev) => {
          const filtered = (prev || []).filter((shift) => monthKeyOf(shift?.date) !== monthPrefix);
          return [...filtered, ...normalizedUpdated];
        });

        if (data.updatedProject) {
          setProjects(prev => {
            const exists = prev.some(p => p._id === data.updatedProject._id);

            if (exists) {
              return prev.map(p =>
                p._id === data.updatedProject._id ? data.updatedProject : p
              );
            }

            return [...prev, data.updatedProject]; // 🔥 THIS IS WHAT YOU'RE MISSING
          });
        }

        setButtonLoading(false);
        resetShiftPopupState();
        setSelectEmployeePopupVisible(false);
        setIsEditing(false);
      } else {
        console.log("Kunde inte redigera pass:", data.errorText);
        setButtonLoading(false);
        setToastType("error");
        setToastMessage(
          "Kunde inte redigera pass, om det fortsätter att inte fungera vänligen skicka ett mail till kontakt@timesmart.se!"
        );
        return;
      }
    } else {
      if (!selectedTimeSchema) {
        setToastType("error");
        setToastMessage("Du måste välja ett schema innan du kan lägga till pass!");
        setButtonLoading(false);
        return handleClosePopup();
      }

      const data = await add_new_worksession({
        user,
        company,
        ...(isNonEmptyLocal(shiftFormData.project) ? { projectId: shiftFormData.project } : {}),
        workSessionData: workSessionDataCreate,
        timeSchemaId: selectedTimeSchema,
      });

      if (data.status === "success") {
        const normalizedUpdated = (data.updatedShiftsForMonth || []).map((s) => ({
          ...s,
          date: toISODate(s.date),
        }));
        const affectedMonths = [
          ...new Set(normalizedUpdated.map((s) => monthKeyOf(s.date)).filter(Boolean)),
        ];

        setShifts((prev) => {
          const filtered = (prev || []).filter(
            (shift) => !affectedMonths.includes(monthKeyOf(shift?.date))
          );
          return [...filtered, ...normalizedUpdated];
        });

        setDraftSchedule((prev) => {
          const filtered = (prev || []).filter(
            (shift) => !affectedMonths.includes(monthKeyOf(shift?.date))
          );
          return [...filtered, ...normalizedUpdated];
        });

        if (data.updatedProject) {
          setProjects(prev => {
            const exists = prev.some(p => p._id === data.updatedProject._id);

            if (exists) {
              return prev.map(p =>
                p._id === data.updatedProject._id ? data.updatedProject : p
              );
            }

            return [...prev, data.updatedProject]; // 🔥 THIS IS WHAT YOU'RE MISSING
          });
        }

        setButtonLoading(false);
        resetShiftPopupState();
        setSelectEmployeePopupVisible(false);
        setIsEditing(false);
      } else {
        handleClosePopup();
        setButtonLoading(false);
        setToastType("error");
        setToastMessage(
          "Kunde inte skapa pass, om det fortsätter att inte fungera vänligen skicka ett mail till kontakt@timesmart.se!"
        );
        return;
      }
    }

    setShiftFormData({
      employees: [{ employeeId: "", overtime: [], absences: [], breaks: [] }],
      project: "",
      additionalProject: "",
      allowApplications: false,
      userSelection: "",
      date: "",
      startTime: "",
      endTime: "",
    });
    setSelectEmployeePopupVisible(false);
    setIsEditing(false);
  };




  const handleShiftDelete = async () => {
    try {
      setDeleteLoading(true);

      const data = await remove_worksession({ user, company, worksession: editWorksession, timeSchemaId: selectedTimeSchema });

      if (data.status === "success") {
        const updatedShiftsForMonth = data.updatedShiftsForMonth;
        const monthPrefix = `${data.year}-${String(data.month).padStart(2, "0")}`;
        const normalizedUpdated = (updatedShiftsForMonth || []).map(s => ({ ...s, date: toISODate(s.date) }));

        setShifts((prevShifts) => {
          const filtered = (prevShifts || []).filter(
            (shift) => shift._id !== data.shiftId && monthKeyOf(shift?.date) !== monthPrefix
          );
          return [...filtered, ...normalizedUpdated];
        });

        setDraftSchedule((prevSchedule) => {
          const filtered = (prevSchedule || []).filter(
            (shift) => shift._id !== data.shiftId && monthKeyOf(shift?.date) !== monthPrefix
          );
          return [...filtered, ...normalizedUpdated];
        });

        resetShiftPopupState();
        setSelectEmployeePopupVisible(false);
        setIsEditing(false);

      } else {
        setToastType("error");
        setToastMessage("Kunde inte radera pass, om det fortsätter att inte fungera vänligen skicka ett mail till kontakt@timesmart.se!");
      }
    } catch (err) {
      console.error("Delete failed", err);
      setToastType("error");
      setToastMessage("Ett fel uppstod vid radering.");
    } finally {
      setDeleteLoading(false);
    }
  };


  const handleBulkDelete = async () => {
    if (selectedShiftIds.size === 0 && selectedDates.size === 0) {
      setToastType("error");
      setToastMessage("Inget valt att radera");
      return;
    }

    if (!window.confirm("Är du säker på att du vill radera valda pass?")) {
      return;
    }

    try {
      setDeleteLoading(true);

      const data = await bulk_delete_worksessions({
        user,
        company,
        timeSchemaId: selectedTimeSchema,
        shiftIds: Array.from(selectedShiftIds),
        dates: Array.from(selectedDates),
      });

      if (data.status === "success") {
        const updatedShiftsForMonth = data.updatedShiftsForMonth || [];

        // ✅ NORMALISERA ALLT SOM KOMMER FRÅN BACKEND
        const normalizedUpdated = updatedShiftsForMonth.map(s => ({
          ...s,
          date: toISODate(s.date),
        }));

        const affectedMonths = [
          ...new Set(
            normalizedUpdated
              .map(s => monthKeyOf(s.date))
              .filter(Boolean)
          ),
        ];

        // 🔥 FIX: normalisera s.date i filter
        setShifts(prev => {
          const filtered = prev.filter(s => {
            const normalizedDate = toISODate(s.date);

            return (
              !selectedShiftIds.has(s._id) &&
              !selectedDates.has(normalizedDate) &&
              !affectedMonths.includes(monthKeyOf(normalizedDate))
            );
          });

          return [...filtered, ...normalizedUpdated];
        });

        // 🔥 SAMMA FIX HÄR
        setDraftSchedule(prev => {
          const filtered = prev.filter(s => {
            const normalizedDate = toISODate(s.date);

            return (
              !selectedShiftIds.has(s._id) &&
              !selectedDates.has(normalizedDate) &&
              !affectedMonths.includes(monthKeyOf(normalizedDate))
            );
          });

          return [...filtered, ...normalizedUpdated];
        });

        // 🔥 Reset UI state
        setSelectedShiftIds(new Set());
        setSelectedDates(new Set());
        setDeleteMode(false);

        setToastType("success");
        setToastMessage("Pass raderade");

      } else {
        setToastType("error");
        setToastMessage(data.errorText || "Kunde inte radera");
      }
    } catch (err) {
      console.error(err);
      setToastType("error");
      setToastMessage("Fel vid radering");
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleRestoreShifts = (restoredShifts) => {
    if (!restoredShifts?.length) return;

    const toISODate = (d) => {
      if (!d) return "";
      if (typeof d === "string") return d.includes("T") ? d.split("T")[0] : d;
      return new Date(d).toISOString().split("T")[0];
    };

    const normalized = restoredShifts.map(s => ({
      ...s,
      date: toISODate(s.date),
    }));

    // 🔥 ONLY ADD (no filtering)
    setShifts(prev => {
      const existingIds = new Set(prev.map(s => s._id));
      const newOnes = normalized.filter(s => !existingIds.has(s._id));
      return [...prev, ...newOnes];
    });

    setDraftSchedule(prev => {
      const existingIds = new Set(prev.map(s => s._id));
      const newOnes = normalized.filter(s => !existingIds.has(s._id));
      return [...prev, ...newOnes];
    });
  };



  const resetShiftPopupState = () => {
    setOverlappingShiftWarningText("");
    setEmployeesNotInProject([]);

    setShiftFormData({
      employees: [{ employeeId: "", overtime: [], absences: [], breaks: [] }],
      project: "",
      additionalProject: "",
      userSelection: "",
      allowApplications: false,
      date: "",
      startTime: "",
      endTime: "",
      message: ""
    });

    // Viktigt:
    setUseMultipleDates(false);
    setMultipleDates([]);
    setSelectedMultipleStartDate(null);
    setSelectedMultipleEndDate(null);
    setSelectedMultipleMode("weekday");
    setSelectedMultipleWeekdays({ 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 0: false });
    setSelectedMultipleCustomDates([]);

    setShowOverTimeForShiftPopup(false);
    setShowAbsenceForShiftPopup(false);
    setShowBreakPopup(false);
    setShowMultipleDatesShiftPopup(false);

    setSelectedBreakIndex(null);
    setSelectedAbsenceIndex(null);
    setSelectedOvertimeIndex(null);
    setSelectedEmployeeForBreak(null);
    setSelectedEmployeeForAbsence(null);
    setSelectedEmployeeForOvertime(null);
  };

  const handleClosePopup = async () => {
    try {
      if (buttonLoading || deleteLoading) return;
      resetShiftPopupState();
      setSelectEmployeePopupVisible(false);
      setIsEditing(false);
      setPublishPopupVisible(false);
      setShowCreateTimeSchemaPopup(false);
    } catch (error) {
      setToastType("error");
      setToastMessage("Kan inte stänga popup, vänligen uppdatera sidan!");
    }
  };

  const createNewTimeSchema = async () => {
    setLoading(true)

    if (newTimeSchemaName === "") {
      setToastType("error");
      setToastMessage("Schemat måste ha ett namn!");
      setLoading(false);
      return;
    }

    const data = await create_new_timeSchema({ timeSchemaName: newTimeSchemaName, user, company })

    if (data.status === "success") {
      setAllTimeSchemas(data.timeSchemas)
      setTimeSchemas(data.timeSchemas)
      setNewTimeSchemaName("")
      setSelectedTimeSchema(data.newTimeSchemaId)
      setMostRecentTimeSchema(data.newTimeSchemaId)
      handleClosePopup()
      setShifts([])
      window.location.reload()
    }
    else {
      setToastType("error");
      setToastMessage("Schemat kunde inte skapas!");
    }
    setLoading(false)
  }

  const handleDeleteTimeSchema = async (timeSchemaId) => {
    const timeSchemaName = allTimeSchemas.find((schema) => schema._id === timeSchemaId).name
    if (window.confirm(`Är du säker på att du vill radera tidsschemat och alla passen i ${timeSchemaName} schemat?`)) {

      const userInput = prompt(
        `Den här åtgärden kommer att permanent radera schemat "${timeSchemaName}" och alla tillhörande pass, samt ta bort alla användares timmar som existerade på schemat.\n\nSkriv "${timeSchemaName}" för att bekräfta:`
      );

      if (userInput === timeSchemaName) {
     
        const data = await delete_existing_timeSchema({ user, company, timeSchemaId })
        console.log("DELETE RESPONSE:", data);

        if (data.status === "success") {
          setMostRecentTimeSchema(null)
          handleClosePopup()
          setShifts([])
          return window.location.reload()
        }
        else {
          setToastType("error");
          setToastMessage(data.errorText || "Kunde inte radera tidsschema, vänligen uppdatera sidan och försök igen");
        }
        
      }

    }
  }

  const switchTimeSchemaPopupState = (state) => {
    setDeleteTimeSchema(state)
  }

  const CreateNewTimeSchemaPopup = () => (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, }} onClick={handleClosePopup}>
      <div style={{ backgroundColor: '#fff', borderRadius: 12, padding: 24, width: 480, minHeight: 330, maxHeight: 330, maxWidth: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', gap: 16, borderBottom: '1px solid #eee', marginBottom: 20 }}>
          <p style={{ cursor: 'pointer', padding: '8px 16px', margin: 0, fontWeight: deleteTimeSchema ? 400 : 600, color: deleteTimeSchema ? '#666' : '#2c3e50', borderBottom: `3px solid ${!deleteTimeSchema ? '#3498db' : 'transparent'}`, transition: 'all 0.2s' }} onClick={() => switchTimeSchemaPopupState(false)}>Skapa</p>
          <p style={{ cursor: 'pointer', padding: '8px 16px', margin: 0, fontWeight: deleteTimeSchema ? 600 : 400, color: deleteTimeSchema ? '#2c3e50' : '#666', borderBottom: `3px solid ${deleteTimeSchema ? '#e74c3c' : 'transparent'}`, transition: 'all 0.2s' }} onClick={() => switchTimeSchemaPopupState(true)}>Radera</p>
        </div>

        <h1 style={{ margin: '0 0 20px 0', fontSize: 20, color: '#2c3e50', fontWeight: 600 }}>{deleteTimeSchema ? "Radera schema" : "Skapa nytt schema"}</h1>

        {!deleteTimeSchema ? (
          <>
            <label style={{ display: 'block', marginBottom: 8, fontSize: 14, color: '#7f8c8d', fontWeight: 500 }}>Namn på Schemat:</label>
            <input
              type="text"
              style={{ width: '100%', padding: '10px 14px', border: '1px solid #bdc3c7', borderRadius: 8, marginBottom: 24, fontSize: 14, transition: 'border 0.2s', outline: 'none' }}
              placeholder="Exempel: schema för Lager"
              value={newTimeSchemaName}
              onChange={(e) => setNewTimeSchemaName(e.target.value)}
            />
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button style={{ padding: '10px 20px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, transition: 'background 0.2s' }} onClick={createNewTimeSchema}>Skapa</button>
              <button style={{ padding: '10px 20px', backgroundColor: 'transparent', color: '#7f8c8d', border: '1px solid #bdc3c7', borderRadius: 8, cursor: 'pointer', fontWeight: 600, transition: 'all 0.2s' }} onClick={handleClosePopup}>Avbryt</button>
            </div>
          </>
        ) : (
          <div style={{ width: '100%' }}>
            <label style={{ display: 'block', marginBottom: 12, fontSize: 14, color: '#7f8c8d', fontWeight: 500 }}>Välj ett Schema att radera:</label>
            <div style={{ overflowY: "scroll", maxHeight: 150 }}>
              {allTimeSchemas.map(schema => (
                <div key={schema._id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f9f9f9', borderRadius: 8, marginBottom: 8 }}>
                  <span style={{ color: '#2c3e50', fontSize: 14 }}>{schema.name}</span>
                  <button onClick={() => handleDeleteTimeSchema(schema._id)} style={{ padding: '6px 12px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>Radera</button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const isValidDateFormat = (str) => {
    return /^\d{4}-\d{2}-\d{2}$/.test(str);
  };

  const handlePublishScheduleClicked = async () => {
    if (!selectedTimeSchema) {
      setToastType("error");
      setToastMessage("Du måste ha valt ett schema för att publicera passen!");
      return
    }
    if (!newPublishDate) {
      setToastType("error");
      setToastMessage("Du måste skriva ett nytt publiceringsdatum!");
      return
    }

    if (!isValidDateFormat(newPublishDate)) {
      setToastType("error");
      setToastMessage("Datumet måste vara ifyllt och vara i formatet ÅÅÅÅ-MM-DD.");
      return;
    }

    if (window.confirm(`Är du säkert att du vill publicera schemat fram till ${newPublishDate}, när det är publicerat kommer alla personer med appen få tillgång till dem publicerade passen.`)) {
      setLoading(true)
      const data = await publish_draft_schedule({ user, company, timeSchema: selectedTimeSchema, newPublishDate })

      if (data.status === "success") {
        const updateMap = new Map(data.updatedShifts.map(s => [s._id.toString(), s.isPublished]));

        setShifts(prev =>
          prev.map(shift =>
            updateMap.has(shift._id.toString())
              ? { ...shift, isPublished: updateMap.get(shift._id.toString()) }
              : shift
          )
        );

        setDraftSchedule(prev =>
          prev.map(shift =>
            updateMap.has(shift._id.toString())
              ? { ...shift, isPublished: updateMap.get(shift._id.toString()) }
              : shift
          )
        );
        setToastType("success");
        setToastMessage("Schemat är publicerat fram till " + data.newLastPublishDate);

        setLastPublishedDate(data.newLastPublishDate);
        setNewPublishDate(data.newLastPublishDate);

        setTimeSchemas(prevSchemas =>
          prevSchemas.map(schema =>
            schema._id === selectedTimeSchema
              ? { ...schema, lastPublishedDate: data.updatedTimeSchema.lastPublishedDate }
              : schema
          )
        );

        setMostRecentTimeSchema(data.updatedTimeSchema._id);

        setPublishConfirmText("");
        handleClosePopup();
      }
      else {
        setToastType("error");
        setToastMessage(data.errorText);
        handleClosePopup()

      }
      setLoading(false)
    }
  }

  const handleRecallScheduleClicked = async () => {
    if (!selectedTimeSchema) {
      setToastType("error");
      setToastMessage("Du måste ha valt ett schema för att återkalla passen!");
      return
    }
    if (!newPublishDate) {
      setToastType("error");
      setToastMessage("Du måste ge ett nytt återkallningsdatum");
      return
    }

    if (!isValidDateFormat(newPublishDate)) {
      setToastType("error");
      setToastMessage("Datumet måste vara ifyllt och vara i formatet ÅÅÅÅ-MM-DD.");
      return;
    }

    if (window.confirm(`Är du säkert att du vill återkalla schemat från ${new Date(lastPublishedDate).toLocaleDateString('sv-SE')} till ${newPublishDate}`)) {
      setLoading(true)
      const data = await recall_draft_schedule({ user, company, timeSchema: selectedTimeSchema, newRecallDate: newPublishDate })

      if (data.status === "success") {
        const updateMap = new Map(data.updatedShifts.map(s => [s._id.toString(), s.isPublished]));

        setShifts(prev =>
          prev.map(shift =>
            updateMap.has(shift._id.toString())
              ? { ...shift, isPublished: updateMap.get(shift._id.toString()) }
              : shift
          )
        );

        setDraftSchedule(prev =>
          prev.map(shift =>
            updateMap.has(shift._id.toString())
              ? { ...shift, isPublished: updateMap.get(shift._id.toString()) }
              : shift
          )
        );
        setLastPublishedDate(data.newLastPublishDate)
        setNewPublishDate(data.newLastPublishDate)
        setToastType("success");
        setToastMessage("Schemat är nu återkallat tillbaka till " + newPublishDate);

        setTimeSchemas(prevSchemas =>
          prevSchemas.map(schema =>
            schema._id === selectedTimeSchema
              ? { ...schema, lastPublishedDate: data.updatedTimeSchema.lastPublishedDate }
              : schema
          )
        );

        setMostRecentTimeSchema(data.updatedTimeSchema._id);

        handleClosePopup()
      }
      else {
        setToastType("error");
        setToastMessage(data.errorText);
        handleClosePopup()
      }
      setLoading(false)
    }
  }

  const handleImportedShifts = (newShifts) => {
    setShifts(newShifts);
    setDraftSchedule(newShifts)
  };

  const importExcelPopup = () => {
    return (
      <ImportExcelPopup
        onClose={() => setImportExcelPopupVisible(false)}
        user={user}
        company={company}
        timeSchema={selectedTimeSchema}
        lastPublishedDate={lastPublishedDate}
        onImportSuccess={handleImportedShifts}
        selectedTimeSchema={selectedTimeSchema}
      />
    )
  }

  const switchPublishState = (state) => {
    const now = new Date();
    const tzOffsetMin = now.getTimezoneOffset();
    const isoToday = new Date(now.getTime() - tzOffsetMin * 60000)
      .toISOString()
      .slice(0, 10); // "YYYY-MM-DD"
    setNewPublishDate(isoToday);
    setRecallPublish(state);
  };

  const publishSchedulePopup = () => {
    const minValue = lastPublishedDate && recallPublish === false ? lastPublishedDate : "";
    const maxValue = lastPublishedDate && recallPublish === true ? lastPublishedDate : "";

    return (
      <div className="publish-schedule-popup-overlay" onClick={() => handleClosePopup()}>
        <div className="publish-schedule-popup" onClick={(e) => e.stopPropagation()}>

          <div className="publish-schedule-header">
            <p
              id="publish-button"
              className={recallPublish === false ? "active-tab" : "inactive-tab"}
              onClick={() => switchPublishState(false)}>
              Publicera
            </p>
            <p
              id="recall-button"
              className={recallPublish === true ? "active-tab" : "inactive-tab"}
              onClick={() => switchPublishState(true)}>
              Återkalla
            </p>
            <button
              id="cancel-button"
              className="cancel-tab"
              onClick={() => handleClosePopup()}>
              Avbryt
            </button>
          </div>

          <h2>{recallPublish === false ? "Publicera schemat" : "Återkalla schemat"}</h2>

          <div>
            <label htmlFor="last-date" className="shift-form-label">Senaste datumet som publicerats</label>
            <input
              type="text"
              id="last-date"
              value={lastPublishedDate}
              readOnly
              disabled
              className="shift-form-input"
            />
          </div>

          <div>
            <label htmlFor="new-date" className="shift-form-label">
              {recallPublish === false ? "Publicera schemat fram till:" : "Återkalla schemat tillbaka till:"}
            </label>
            <input
              type="date"
              id="new-date"
              value={newPublishDate}
              onChange={(e) => setNewPublishDate(e.target.value)}
              required
              className="shift-form-input"
              min={minValue}
              max={maxValue}
            />
          </div>

          <div>
            <label htmlFor="schema-input" className="shift-form-label">Tidsschema</label>
            <input
              type="text"
              id="schema-input"
              value={allTimeSchemas.find((schema) => schema._id === selectedTimeSchema)?.name || "Inget tidsschema valt!"}
              readOnly
              className="shift-form-input"
            />
          </div>

          <button
            id="confirm-button"
            className="publish-schedule-confirm-button"
            onClick={recallPublish === false ? handlePublishScheduleClicked : handleRecallScheduleClicked}>
            <p><strong>{recallPublish === false ? "Publicera" : "Återkalla"}</strong></p>
          </button>
        </div>
      </div>
    );
  };



  

  const goToDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) return;
    setCurrentDate(newDate);
    setCurrentYear(newDate.getFullYear());

    const month = newDate.getMonth() + 1;
    const year = newDate.getFullYear();
    fetchShiftsForMonth(month, year);
  };


  const timeToMinutes = (t) => {
    if (!t) return null;
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };

  const getWholeShiftAbsence = (shift, employee) => {
    if (!shift?.startTime || !shift?.endTime) return null;
    if (!employee?.absences?.length) return null;

    const toMin = (t) => {
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };

    const shiftStart = toMin(shift.startTime);
    const shiftEnd   = toMin(shift.endTime);

    for (const abs of employee.absences) {
      if (abs.appliesWholeShift) return abs;

      if (!abs.from || !abs.to) continue;

      const absStart = toMin(abs.from);
      const absEnd   = toMin(abs.to);

      if (absStart <= shiftStart && absEnd >= shiftEnd) {
        return abs;
      }
    }

    return null;
  };

  const changeWeek = (weeks) => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + weeks * 7);
    setCurrentDate(newDate);
    setCurrentYear(newDate.getFullYear());

    const preloadWeeks = [-1, 0, 1]; // previous, current, next
    const seen = new Set();

    preloadWeeks.forEach((weekOffset) => {
      const baseDate = new Date(newDate);
      baseDate.setDate(baseDate.getDate() + weekOffset * 7);

      const monday = new Date(baseDate);
      const dayOfWeek = (monday.getDay() + 6) % 7;
      monday.setDate(monday.getDate() - dayOfWeek);

      for (let i = 0; i < 7; i++) {
        const day = new Date(monday);
        day.setDate(monday.getDate() + i);
        const year = day.getFullYear();
        const month = String(day.getMonth() + 1).padStart(2, "0");
        const key = `${year}-${month}`;

        if (!loadedMonthsRef.current.has(key) && !seen.has(key)) {
          seen.add(key);
          fetchShiftsForMonth(parseInt(month), year);
        }
      }
    });
  };

  const [inputValue, setInputValue] = useState('');
  const [projectInputValue, setProjectInputValue] = useState('');



  const calculateIsPublished = ({
    shiftDate,
    lastPublishedDate,
  }) => {

    if (!shiftDate || !lastPublishedDate) {
      return false;
    }

    return (
      new Date(shiftDate) <=
      new Date(lastPublishedDate)
    );
  };


  const handleMoveShift = async ({
    shiftId,
    newDate,
    copyMode,
  }) => {

    

    const shiftToMove = shifts.find(
      (s) => s._id === shiftId
    );

    if (!shiftToMove) {
      return;
    }

    if (copyMode) {

      try {

        const copiedEmployees =
          Array.isArray(
            shiftToMove.employees
          )
            ? shiftToMove.employees.map(
                (emp) => ({
                  ...emp,
                })
              )
            : [];

        const data =
          await add_new_worksession({

            user,
            company,

            projectId:
              shiftToMove.project,

            timeSchemaId:
              selectedTimeSchema,

            workSessionData: {

              employees:
                copiedEmployees,

              project:
                shiftToMove.project,

              date:
                newDate,

              startTime:
                shiftToMove.startTime,

              endTime:
                shiftToMove.endTime,

              allowApplications:
                !!shiftToMove.allowApplications,

              disableBreakTime:
                !!shiftToMove.disableBreakTime,

              breakStartTime:
                shiftToMove.breakStartTime
                || "",

              breakEndTime:
                shiftToMove.breakEndTime
                || "",

              message:
                shiftToMove.message || "",
            },
          });

        if (
          data.status === "success"
        ) {

          const updatedShifts =
            data.updatedShiftsForMonth
            || [];

          setShifts((prev) => {

            const existingIds =
              new Set(
                prev.map(
                  (s) => s._id
                )
              );

            const newOnes =
              updatedShifts.filter(
                (s) =>
                  !existingIds.has(
                    s._id
                  )
              );

            return [
              ...prev,
              ...newOnes,
            ];
          });

          setDraftSchedule((prev) => {

            const existingIds =
              new Set(
                prev.map(
                  (s) => s._id
                )
              );

            const newOnes =
              updatedShifts.filter(
                (s) =>
                  !existingIds.has(
                    s._id
                  )
              );

            return [
              ...prev,
              ...newOnes,
            ];
          });

          return;
        }

      } catch (err) {

        console.error(err);

        setToastType("error");

        setToastMessage(
          "Kunde inte kopiera pass"
        );

        return;
      }
    }

    // Ingen ändring
    if (shiftToMove.date === newDate) {
      return;
    }

    // OPTIMISTIC UPDATE
    setShifts((prev) =>
      prev.map((s) =>
        s._id === shiftId
          ? {
              ...s,
              date: newDate,
              isPublished:
                calculateIsPublished({
                  shiftDate: newDate,
                  lastPublishedDate,
                }),
            }
          : s
      )
    );

    setDraftSchedule((prev) =>
      prev.map((s) =>
          s._id === shiftId
            ? {
                ...s,

                date: newDate,

                isPublished:
                  calculateIsPublished({
                    shiftDate: newDate,
                    lastPublishedDate,
                  }),
              }
            : s
        )
    );

    try {

      const data =
        await edit_worksession({

          updatedFields: {
            date: newDate,
          },

          user,
          company,

          worksession:
            shiftToMove,

          projectId:
            shiftToMove.project,

          timeSchemaId:
            selectedTimeSchema,
        });

      if (
        data.status !== "success"
      ) {

        // rollback
        setShifts((prev) =>
          prev.map((s) =>
            s._id === shiftId
              ? shiftToMove
              : s
          )
        );

        setDraftSchedule((prev) =>
          prev.map((s) =>
            s._id === shiftId
              ? shiftToMove
              : s
          )
        );

        setToastType("error");

        setToastMessage(
          "Kunde inte flytta pass"
        );
      }

    } catch (err) {

      console.error(err);

      // rollback
      setShifts((prev) =>
        prev.map((s) =>
          s._id === shiftId
            ? shiftToMove
            : s
        )
      );

      setDraftSchedule((prev) =>
        prev.map((s) =>
          s._id === shiftId
            ? shiftToMove
            : s
        )
      );

      setToastType("error");

      setToastMessage(
        "Kunde inte flytta pass"
      );
    }
  };



  const renderWeek = () => {
    const monday = new Date(currentDate);
    const currentDayOfWeek = (monday.getDay() + 6) % 7; // Monday = 0
    monday.setDate(monday.getDate() - currentDayOfWeek);

    const days = ['MÅNDAG', 'TISDAG', 'ONSDAG', 'TORSDAG', 'FREDAG', 'LÖRDAG', 'SÖNDAG'];


    return (
      <div className="week-grid">

        {days.map((day, index) => {

          const currentDay = new Date(monday);

          currentDay.setDate(
            monday.getDate() + index
          );

          return (
            <WeekDayHeader
              key={index}

              currentDay={currentDay}

              day={day}

              index={index}
            />
          );
        })}

        {days.map((_, dayIndex) => {

          const currentDay = new Date(monday);

          currentDay.setDate(
            monday.getDate() + dayIndex
          );

          currentDay.setHours(12, 0, 0, 0);

          return (
            <ShiftGridDay
              key={dayIndex}

              // DAY
              currentDay={currentDay}

              // DATA
              shifts={shifts}
              selectedTimeSchema={
                selectedTimeSchema
              }

              allEmployees={allEmployees}
              allProjects={allProjects}
              allAbsenceRules={
                allAbsenceRules
              }

              // FILTERS
              selectedEmployee={
                selectedEmployee
              }

              selectedProject={
                selectedProject
              }

              // DELETE MODE
              deleteMode={deleteMode}
              deleteType={deleteType}

              selectedShiftIds={
                selectedShiftIds
              }

              selectedDates={
                selectedDates
              }

              setSelectedShiftIds={
                setSelectedShiftIds
              }

              setSelectedDates={
                setSelectedDates
              }

              // SHIFT EDITING
              setIsEditing={setIsEditing}

              setEditWorksession={
                setEditWorksession
              }

              setShiftFormData={
                setShiftFormData
              }

              setSelectEmployeePopupVisible={
                setSelectEmployeePopupVisible
              }

              onMoveShift={handleMoveShift}

              // PERMISSIONS
              canEditShifts={
                canEditShifts
              }

              // HELPERS
              getWholeShiftAbsence={
                getWholeShiftAbsence
              }

              styleForVariant={
                styleForVariant
              }

              badgeForVariant={
                badgeForVariant
              }

              applicationBadge={
                applicationBadge
              }

              buildTooltip={
                buildTooltip
              }
            />
          );
        })}
      </div>
    );
  };



  

            const renderMonth = () => {
                const days = ['MÅNDAG', 'TISDAG', 'ONSDAG', 'TORSDAG', 'FREDAG', 'LÖRDAG', 'SÖNDAG'];

                const year = currentDate.getFullYear();
                const monthIndex = currentDate.getMonth(); // 0–11

                const firstOfMonth = new Date(year, monthIndex, 1);
                const lastOfMonth = new Date(year, monthIndex + 1, 0);

                // Hitta första måndagen som täcker månaden
                const firstMonday = new Date(firstOfMonth);
                const firstDow = (firstMonday.getDay() + 6) % 7; // 0 = måndag
                firstMonday.setDate(firstMonday.getDate() - firstDow);

                const weeks = [];
                let weekStart = new Date(firstMonday);
                let safety = 0;

                // Rendera veckor tills vi passerat månaden, minst 4 rader, max 6
                while (weekStart <= lastOfMonth || weeks.length < 4) {
                  const monday = new Date(weekStart);

                  const weekEl = (
                    <div
                      key={monday.toISOString()}
                      className="week-grid month-week-grid"
                    >

                    {days.map((day, index) => {

                        const currentDay = new Date(monday);

                        currentDay.setDate(
                          monday.getDate() + index
                        );

                        return (
                          <WeekDayHeader
                            key={index}

                            currentDay={currentDay}

                            day={day}

                            index={index}
                          />
                        );
                      })}


                      {days.map((_, dayIndex) => {

                      const currentDay = new Date(monday);

                      currentDay.setDate(
                        monday.getDate() + dayIndex
                      );

                      currentDay.setHours(12, 0, 0, 0);

                      return (
                        <ShiftGridDay
                          key={dayIndex}

                          // DAY
                          currentDay={currentDay}

                          // DATA
                          shifts={shifts}

                          selectedTimeSchema={
                            selectedTimeSchema
                          }

                          allEmployees={allEmployees}
                          allProjects={allProjects}
                          allAbsenceRules={
                            allAbsenceRules
                          }

                          // FILTERS
                          selectedEmployee={
                            selectedEmployee
                          }

                          selectedProject={
                            selectedProject
                          }

                          // DELETE MODE
                          deleteMode={deleteMode}
                          deleteType={deleteType}

                          selectedShiftIds={
                            selectedShiftIds
                          }

                          selectedDates={
                            selectedDates
                          }

                          setSelectedShiftIds={
                            setSelectedShiftIds
                          }

                          setSelectedDates={
                            setSelectedDates
                          }

                          // SHIFT EDITING
                          setIsEditing={setIsEditing}

                          setEditWorksession={
                            setEditWorksession
                          }

                          setShiftFormData={
                            setShiftFormData
                          }

                          setSelectEmployeePopupVisible={
                            setSelectEmployeePopupVisible
                          }

                          onMoveShift={handleMoveShift}

                          // PERMISSIONS
                          canEditShifts={
                            canEditShifts
                          }

                          // HELPERS
                          getWholeShiftAbsence={
                            getWholeShiftAbsence
                          }

                          styleForVariant={
                            styleForVariant
                          }

                          badgeForVariant={
                            badgeForVariant
                          }

                          applicationBadge={
                            applicationBadge
                          }

                          buildTooltip={
                            buildTooltip
                          }
                        />
                      );
                    })}
                    </div>
                  );

                  weeks.push(weekEl);

                  // nästa vecka
                  weekStart = new Date(weekStart);
                  weekStart.setDate(weekStart.getDate() + 7);

                  safety += 1;
                  if (safety > 6) break; // max 6 veckor
                }

                return (
                  <div className="month-stack">
                    {weeks}
                  </div>
                );
              };







// Hämta alla pass för samma datum som redigeras/skapas
const allShiftsForDay = shifts.filter(shift => shift.date === shiftFormData.date);

const baseButtonStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 42,
  height: 42,
  borderRadius: 8,
  fontSize: 18,
  transition: "background 0.15s ease, border 0.15s ease, filter 0.15s ease",
};

const handleHoverIn = (e) => {
  e.currentTarget.style.filter = "brightness(0.92)";
};

const handleHoverOut = (e) => {
  e.currentTarget.style.filter = "brightness(1)";
};


return (
  <div className="nav-container">

    <ShiftTopBar
      selectedTimeSchema={selectedTimeSchema}
      handleChangeTimeSchema={handleChangeTimeSchema}
      allTimeSchemas={allTimeSchemas}

      viewMode={viewMode}
      setViewMode={setViewMode}

      currentDate={currentDate}
      setCurrentDate={setCurrentDate}

      changeWeek={changeWeek}
      fetchShiftsForMonth={fetchShiftsForMonth}

      showCalendar={showCalendar}
      setShowCalendar={setShowCalendar}

      selectedCalendarDate={selectedCalendarDate}
      setSelectedCalendarDate={setSelectedCalendarDate}

      calendarRef={calendarRef}
      goToDate={goToDate}

      inputValue={inputValue}
      setInputValue={setInputValue}

      projectInputValue={projectInputValue}
      setProjectInputValue={setProjectInputValue}

      allEmployees={allEmployees}
      allProjects={allProjects}

      selectedEmployee={selectedEmployee}
      setSelectedEmployee={setSelectedEmployee}

      selectedProject={selectedProject}
      setSelectedProject={setSelectedProject}

      lastPublishedDate={lastPublishedDate}

      canEditShifts={canEditShifts}
      setPublishPopupVisible={setPublishPopupVisible}

      handleHoverIn={handleHoverIn}
      handleHoverOut={handleHoverOut}

      setSelectEmployeePopupVisible={setSelectEmployeePopupVisible}
      setIsEditing={setIsEditing}

      setDeleteMode={setDeleteMode}
      deleteMode={deleteMode}

      setDeleteType={setDeleteType}
      deleteType={deleteType}

      selectedShiftIds={selectedShiftIds}
      selectedDates={selectedDates}

      setSelectedShiftIds={setSelectedShiftIds}
      setSelectedDates={setSelectedDates}

      handleBulkDelete={handleBulkDelete}

      setShowCreateTimeSchemaPopup={setShowCreateTimeSchemaPopup}

      moreButtonRef={moreButtonRef}

      setMoreMenuPosition={setMoreMenuPosition}
      setShowMoreMenu={setShowMoreMenu}

      showMoreMenu={showMoreMenu}
      moreMenuPosition={moreMenuPosition}

      company={company}

      setImportExcelPopupVisible={setImportExcelPopupVisible}
      setShowTrashPopup={setShowTrashPopup}

      setShowCopyWeekPopup={setShowCopyWeekPopup}
    />
    {/* SJÄLVA SCHEMAT */}
  


    <div
  ref={scheduleContainerRef}
  style={{
    position: "relative",
  }}
>
  {viewMode === "week" ? renderWeek() : renderMonth()}
</div>


    {showShiftApplicationsPopup && (
      <ShiftApplicationsPopup
        visible={showShiftApplicationsPopup}
        onClose={() => setShowShiftApplicationsPopup(false)}
      />
    )}

    
    {selectEmployeePopupVisible && (
      
      <ShiftEditorModal
        isOpen={selectEmployeePopupVisible}
        onClose={handleClosePopup}

        isEditing={isEditing}

        shiftFormData={shiftFormData}
        setShiftFormData={setShiftFormData}

        handleShiftSubmit={handleShiftSubmit}
        handleShiftDelete={handleShiftDelete}

        buttonLoading={buttonLoading}
        deleteLoading={deleteLoading}

        allEmployees={allEmployees}
        allProjects={allProjects}
        allAbsenceRules={allAbsenceRules}
        allOvertimeRules={allOvertimeRules}

        canEditShifts={canEditShifts}

        selectedEmployeeForOvertime={selectedEmployeeForOvertime}
        setSelectedEmployeeForOvertime={setSelectedEmployeeForOvertime}

        selectedEmployeeForAbsence={selectedEmployeeForAbsence}
        setSelectedEmployeeForAbsence={setSelectedEmployeeForAbsence}

        selectedEmployeeForBreak={selectedEmployeeForBreak}
        setSelectedEmployeeForBreak={setSelectedEmployeeForBreak}

        selectedOvertimeIndex={selectedOvertimeIndex}
        setSelectedOvertimeIndex={setSelectedOvertimeIndex}

        selectedAbsenceIndex={selectedAbsenceIndex}
        setSelectedAbsenceIndex={setSelectedAbsenceIndex}

        selectedBreakIndex={selectedBreakIndex}
        setSelectedBreakIndex={setSelectedBreakIndex}

        showOvertimeForShiftPopup={showOvertimeForShiftPopup}
        setShowOverTimeForShiftPopup={setShowOverTimeForShiftPopup}

        showAbsenceForShiftPopup={showAbsenceForShiftPopup}
        setShowAbsenceForShiftPopup={setShowAbsenceForShiftPopup}

        showBreakPopup={showBreakPopup}
        setShowBreakPopup={setShowBreakPopup}

        showMultipleDatesShiftPopup={showMultipleDatesShiftPopup}
        setShowMultipleDatesShiftPopup={setShowMultipleDatesShiftPopup}

        multipleDates={multipleDates}
        setMultipleDates={setMultipleDates}

        selectedMultipleStartDate={selectedMultipleStartDate}
        setSelectedMultipleStartDate={setSelectedMultipleStartDate}

        selectedMultipleEndDate={selectedMultipleEndDate}
        setSelectedMultipleEndDate={setSelectedMultipleEndDate}

        selectedMultipleMode={selectedMultipleMode}
        setSelectedMultipleMode={setSelectedMultipleMode}

        selectedMultipleWeekdays={selectedMultipleWeekdays}
        setSelectedMultipleWeekdays={setSelectedMultipleWeekdays}

        selectedMultipleCustomDates={selectedMultipleCustomDates}
        setSelectedMultipleCustomDates={setSelectedMultipleCustomDates}

        useMultipleDates={useMultipleDates}
        setUseMultipleDates={setUseMultipleDates}

        employeesNotInProject={employeesNotInProject}

        overlappingShiftWarningText={overlappingShiftWarningText}


        setToastType={setToastType}
        setToastMessage={setToastMessage}

        company={company}
        user={user}

        allProjects={allProjects}
        setAllProjects={setAllProjects}

        projects={projects}
        setProjects={setProjects}

        setEmployeesNotInProject={setEmployeesNotInProject}
        
        allShiftsToday={allShiftsForDay}   // från förra steget
        currentShiftId={editWorksession?._id}   // 👈 ny prop


        
      />
    )}
    {publishPopupVisible && publishSchedulePopup()}
    {showCreateTimeSchemaPopup && CreateNewTimeSchemaPopup()}
    {importExcelPopupVisible && importExcelPopup()}
    <CopyWeekShiftPopup
      visible={showCopyWeekPopup}
      onClose={() => setShowCopyWeekPopup(false)}

      currentDate={currentDate}

      onConfirm={async ({
        sourceWeek,
        targetWeek,
        settings,
      }) => {

        const data =
          await copy_week_schedule({

            user,
            company,

            sourceWeek,
            targetWeek,

            settings,

            timeSchemaId:
              selectedTimeSchema,
          });

        if (data.status === "success") {

          setShifts(prev => [
            ...prev,
            ...data.createdShifts,
          ]);

          setDraftSchedule(prev => [
            ...prev,
            ...data.createdShifts,
          ]);

          setToastType("success");

          setToastMessage(
            "Veckan kopierades"
          );

          setShowCopyWeekPopup(false);
        }
      }}
    />
    <TrashPopup
      visible={showTrashPopup}
      onClose={() => setShowTrashPopup(false)}
      companyId={company?._id}
      userId={user?._id}
      timeSchemaId={selectedTimeSchema}
      onRestoreShifts={handleRestoreShifts} 
    />


{isDraggingShift && (
  <>

    {/* BLOCKERA SIDENAV */}
    {isDraggingShift && (
      <div
        onDragOver={(e) => {
          console.log("dragging over")
          e.preventDefault();
          e.dataTransfer.dropEffect = "none";
        }}
        onDrop={(e) => {
          e.preventDefault();
        }}
        style={{
          position: "fixed",
          left: 0,
          top: 0,
          width: 250,
          height: "100vh",

          zIndex: 9999999,

          background: "transparent",
        }}
      />
    )}
    {/* Vänster zon – helt transparent, synlig endast vid hover */}
    <div
      onDragEnter={() => startHoverNavigation(-1)}
      onDragLeave={() => {
        if (hoverDirection === -1) clearHoverNavigation();
      }}
      style={{
        position: "fixed",
        left: 250,
        top: 0,
        width: 17,              // bred nog att lätt träffa, men smal så den inte täcker viktigt innehåll
        height: "100vh",
        zIndex: 999999,
        backgroundColor: hoverDirection === -1 ? "rgba(59,130,246,0.25)" : "transparent",
        backdropFilter: hoverDirection === -1 ? "blur(2px)" : "none",
        transition: "background-color 0.2s ease, backdrop-filter 0.2s ease",
        pointerEvents: "all",
        cursor: "pointer",
      }}
    />
    
    {/* Höger zon */}
    <div
      onDragEnter={() => startHoverNavigation(1)}
      onDragLeave={() => {
        if (hoverDirection === 1) clearHoverNavigation();
      }}
      style={{
        position: "fixed",
        right: 0,
        top: 0,
        width: 17,
        height: "100vh",
        zIndex: 999999,
        backgroundColor: hoverDirection === 1 ? "rgba(59,130,246,0.25)" : "transparent",
        backdropFilter: hoverDirection === 1 ? "blur(2px)" : "none",
        transition: "background-color 0.2s ease, backdrop-filter 0.2s ease",
        pointerEvents: "all",
        cursor: "pointer",
      }}
    />
  </>
)}



    <Toast
      message={toastMessage}
      type={toastType}
      onClose={() => setToastMessage("")}
    />
  </div>



);
};



export default Shift;